import React, { useState } from 'react';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHeart as faHeartO } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '../Button';
import { isEnterKey } from '../utils/a11y';

type Props = {
  isFavorited?: boolean;
  sitterId: number;
  favoriteId: number;
  trackingCallback(event: string, params?: Record<string, unknown>): Promise<void>;
  setFavorite(isFavorited: boolean, favoriteId: number, sitterId: number): Promise<void>;
};

export const HeartButton = ({ isFavorited, trackingCallback, setFavorite, sitterId, favoriteId }: Props): JSX.Element => {
  const [favorited, setFavorited] = useState(isFavorited);
  const [animating, setAnimating] = useState(false);

  const handleFavorite = async (): Promise<void> => {
    setAnimating(!favorited);

    const trackingProps = {
      elementId: 'favorite',
      sitterId,
    };

    try {
      await setFavorite(!favorited, favoriteId, sitterId);
      setFavorited(!favorited);
      await trackingCallback('clicked-button', trackingProps);
    } catch (error) {
      console.warn(error);
    }
  }

  const heartColor = favorited ? 'text-bubblegum' : 'text-white';
  const heartStrokeWidth = favorited ? 40 : 4;
  const animation = animating ? 'animate-hearts' : '';

  return (
    <Button
      aria-label={`Heart icon to ${favorited ? 'unfavorite' : 'save as favorite'} caregiver`}
      tabIndex={0}
      onClick={handleFavorite}
      onKeyDown={(e): void => { if (isEnterKey(e)) handleFavorite() }}
    >
      <FontAwesomeIcon
        icon={favorited ? faHeart : faHeartO}
        className={`ml-2 text-2xl absolute ${animation} animation-delay-[700ms] ${heartColor}`}
        stroke='white'
        strokeWidth={heartStrokeWidth}
      />
      <FontAwesomeIcon
        icon={favorited ? faHeart : faHeartO}
        className={`ml-2 text-2xl absolute ${animation} animation-delay-[200ms] ${heartColor}`}
        stroke='white'
        strokeWidth={heartStrokeWidth}
      />
      <FontAwesomeIcon
        icon={favorited ? faHeart : faHeartO}
        className={`ml-2 text-2xl absolute ${animation} ${heartColor}`}
        stroke='white'
        strokeWidth={heartStrokeWidth}
      />
      <FontAwesomeIcon
        icon={favorited ? faHeart : faHeartO}
        className={`ml-2 text-2xl ${heartColor}`}
        stroke='white'
        strokeWidth={heartStrokeWidth}
      />
    </Button>
  );
};
